export default __webpack_public_path__ + "static/media/d8ee10eb12769a55befbb94ee0b5ac021583941218027.d69ff0bd.webp";